import { c as _c } from "react/compiler-runtime";
import { Trans, useTranslation } from 'react-i18next';
import React from 'react';
import Floating from '@/sections/Floating';
import { Link } from '@/components/links';
import { LINKS } from '@/constants/links';
import { FILES } from '@/constants/files';
import { SPRING_OFFER_TRANSLATION_VALUES } from '@/constants/springOffer';
import { useProductRegistrationLink } from '@/hooks/useProductRegistrationLink';
export function HowItWorks() {
  const $ = _c(62);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["springOffer"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  const registrationLink = useProductRegistrationLink("jaro2026");
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <><div className="bgCircle absolute right-0 bottom-0 hidden translate-x-2/3 translate-y-10 lg:block" /><div className="bgCircle absolute top-1/3 left-0 hidden -translate-x-1/4 -translate-y-1/3 rotate-180 lg:block" /></>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== registrationLink) {
    t2 = <Link analyticsParam="springHowItWorksRegistration" testId="springHowItWorksRegistration" to={registrationLink} />;
    $[2] = registrationLink;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t || $[5] !== t2) {
    t3 = <Trans t={t} i18nKey="spring.howItWorks.items.1.text">{t2}</Trans>;
    $[4] = t;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t) {
    t4 = t("spring.howItWorks.items.1.title");
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t) {
    t5 = t("spring.howItWorks.items.1.title");
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t5) {
    t6 = {
      alt: t5,
      src: "/images/sections/spring/cards/cs/1.png"
    };
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t3 || $[14] !== t4 || $[15] !== t6) {
    t7 = {
      anchorKey: "spring.howItWorks.items.1.title",
      content: t3,
      title: t4,
      image: t6,
      variant: "small"
    };
    $[13] = t3;
    $[14] = t4;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t) {
    t8 = t("spring.howItWorks.items.2.text");
    $[17] = t;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t) {
    t9 = t("spring.howItWorks.items.2.title");
    $[19] = t;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t) {
    t10 = t("spring.howItWorks.items.2.title");
    $[21] = t;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== t10) {
    t11 = {
      alt: t10,
      src: "/images/sections/spring/cards/cs/2.png"
    };
    $[23] = t10;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== t11 || $[26] !== t8 || $[27] !== t9) {
    t12 = {
      anchorKey: "spring.howItWorks.items.2.title",
      content: t8,
      title: t9,
      image: t11,
      imagePosition: "right",
      variant: "small"
    };
    $[25] = t11;
    $[26] = t8;
    $[27] = t9;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = {
      support_link: <Link analyticsParam="springHowItWorksRegistration" testId="springHowItWorksRegistration" to={LINKS().login} />
    };
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  let t15;
  if ($[30] !== t) {
    t14 = <Trans t={t} i18nKey="spring.howItWorks.items.3.text" values={SPRING_OFFER_TRANSLATION_VALUES} components={t13} />;
    t15 = t("spring.howItWorks.items.3.title");
    $[30] = t;
    $[31] = t14;
    $[32] = t15;
  } else {
    t14 = $[31];
    t15 = $[32];
  }
  let t16;
  if ($[33] !== t) {
    t16 = t("spring.howItWorks.items.3.title");
    $[33] = t;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  let t17;
  if ($[35] !== t16) {
    t17 = {
      alt: t16,
      src: "/images/sections/spring/cards/cs/3.png"
    };
    $[35] = t16;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  let t18;
  if ($[37] !== t14 || $[38] !== t15 || $[39] !== t17) {
    t18 = {
      anchorKey: "spring.howItWorks.items.3.title",
      content: t14,
      title: t15,
      image: t17,
      variant: "small"
    };
    $[37] = t14;
    $[38] = t15;
    $[39] = t17;
    $[40] = t18;
  } else {
    t18 = $[40];
  }
  let t19;
  if ($[41] !== t12 || $[42] !== t18 || $[43] !== t7) {
    t19 = [t7, t12, t18];
    $[41] = t12;
    $[42] = t18;
    $[43] = t7;
    $[44] = t19;
  } else {
    t19 = $[44];
  }
  let t20;
  if ($[45] !== t) {
    t20 = t("spring.howItWorks.title");
    $[45] = t;
    $[46] = t20;
  } else {
    t20 = $[46];
  }
  let t21;
  if ($[47] !== t) {
    t21 = t("spring.howItWorks.cta");
    $[47] = t;
    $[48] = t21;
  } else {
    t21 = $[48];
  }
  let t22;
  if ($[49] !== registrationLink || $[50] !== t21) {
    t22 = {
      analyticsParam: "springHowItWorksCta",
      testId: "springHowItWorksCta",
      text: t21,
      to: registrationLink
    };
    $[49] = registrationLink;
    $[50] = t21;
    $[51] = t22;
  } else {
    t22 = $[51];
  }
  let t23;
  if ($[52] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = FILES();
    $[52] = t23;
  } else {
    t23 = $[52];
  }
  const t24 = t23.springConditions;
  let t25;
  if ($[53] !== t) {
    t25 = t("spring.howItWorks.conditions");
    $[53] = t;
    $[54] = t25;
  } else {
    t25 = $[54];
  }
  let t26;
  if ($[55] !== t25) {
    t26 = <div className="mt-4 text-center"><Link to={t24} testId="springConditions" target="_blank" analyticsParam="springConditions" className="text-white!">{t25}</Link></div>;
    $[55] = t25;
    $[56] = t26;
  } else {
    t26 = $[56];
  }
  let t27;
  if ($[57] !== t19 || $[58] !== t20 || $[59] !== t22 || $[60] !== t26) {
    t27 = <Floating bgCircles={t1} boxes={t19} title={t20} button={t22} footer={t26} />;
    $[57] = t19;
    $[58] = t20;
    $[59] = t22;
    $[60] = t26;
    $[61] = t27;
  } else {
    t27 = $[61];
  }
  return t27;
}